/* eslint-disable no-nested-ternary */
import { Mutation } from '@apollo/client/react/components';
import PropTypes from 'prop-types';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { formatMiliseconds } from '@playbookux/playbook-web-core';
// admin/pages/analytics/graphql
import { REMOVE_QUOTE } from '../../../../../../../admin/pages/analytics/graphql';

import {
  Card,
  Container,
  Content,
  Description,
  Divider,
  Dropdown,
  DropdownContainer,
  DescriptionContainer,
  FilterContainer,
  Level,
  LevelContainer,
  NoQuotesMessage,
  Quote,
  RemoveIcon,
  Sentence,
  Title,
  // ViewMore,
} from './styles';

const sortFn = (a, b) => {
  const an = a.text.split(' ');
  const bn = b.text.split(' ');

  return Number(an[1]) <= Number(bn[1]) ? -1 : 1;
};

const sortUniqueNames = (col) => {
  let availableGroupNames = col.map((q, i) => ({
    key: i,
    text: q.questionGroupName.replace(/task/ig, 'Question'),
    value: q.questionId,
  }));
  availableGroupNames = _.uniqBy(availableGroupNames, (i) => i.value).sort(sortFn);

  return availableGroupNames;
};

const KeyQuotes = (props) => {
  const {
    data,
    questions,
    onRemoveQuoteClicked,
    title,
    questionsMap,
    project,
  } = props;

  const [dropdownText, setDropdownText] = useState('Filter by Question');
  const [currentTask, setCurrentTask] = useState(null);
  const [filteredData, setFilteredData] = useState(data);

  const availableGroupNames = [{
    key: -1,
    text: 'All',
    value: null,
  }, ...sortUniqueNames(questions)];

  const getSentimentColor = (sentiment) => {
    if (sentiment === 'Positive') {
      return '#A9DD9E';
    }
    if (sentiment === 'Negative') {
      return '#DF7070';
    }

    return '#D8D8D8';
  };

  const onSelectFilter = ((group) => {
    if (!group) {
      setFilteredData(data);
      setCurrentTask(null);
      setDropdownText('All');
    } else {
      setFilteredData(questions.filter((q) => q.questionId === group));
      setCurrentTask(group);
      setDropdownText('Filter by Question');
    }
  });

  useEffect(() => {
    setFilteredData(data);
    setCurrentTask(null);
  }, [data]);

  return (
    <Card>
      <Title>{title}</Title>

      <Description>
        These are quotes that carry a particular sentiment or were a product recommendation.
      </Description>

      <FilterContainer>
        <DropdownContainer>
          <Dropdown
            selection
            placeholder={dropdownText}
            value={currentTask}
            options={availableGroupNames}
            onChange={(e, { value }) => onSelectFilter(value)}
          />
        </DropdownContainer>
        <DescriptionContainer>
          <Description>
            {questionsMap[currentTask] && questionsMap[currentTask].replace(/task/ig, 'Question')}
          </Description>
        </DescriptionContainer>
      </FilterContainer>

      <Container>
        {filteredData.length
          ? filteredData.map((quote, index) => (
            <div key={quote.quoteId}>
              {index > 0 && (
                <Divider />
              )}

              <Quote>
                <Content>
                  <Sentence>
                    {`${quote.sentence} - ${quote?.profile?.firstName} `}
                    {`(${quote.questionGroupName.replace(/task/ig, 'Question')}, ${formatMiliseconds(quote.videoTime)})`}

                    {onRemoveQuoteClicked && (
                      <Mutation
                        mutation={REMOVE_QUOTE}
                        fetchPolicy="no-cache"
                      >
                        {(removeQuote) => (
                          <RemoveIcon
                            onClick={() => {
                              onRemoveQuoteClicked(quote.quoteId);
                              removeQuote({ variables: { id: quote.quoteId } });
                            }}
                          />
                        )}
                      </Mutation>
                    )}
                  </Sentence>
                </Content>

                <LevelContainer>
                  <Level sentimentColor={getSentimentColor(quote.sentimentBySentence)}>
                    {quote.sentimentBySentence}
                  </Level>
                </LevelContainer>
              </Quote>
            </div>
          ))
          : project.status === 'done' && project.nlpProcessed
            ? (
              <NoQuotesMessage>
                <Sentence>
                  We didn&quot;t find any noteworthy quotes for this task.
                </Sentence>
              </NoQuotesMessage>
            )
            : (
              <NoQuotesMessage>
                <Sentence>
                  Quotes will appear once your project is complete
                </Sentence>
              </NoQuotesMessage>
            )}
      </Container>
    </Card>
  );
};

KeyQuotes.propTypes = {
  data: PropTypes.array.isRequired,
  questions: PropTypes.array.isRequired,
  questionsMap: PropTypes.object.isRequired,
  onRemoveQuoteClicked: PropTypes.func,
  title: PropTypes.string.isRequired,
  project: PropTypes.object.isRequired,
};

KeyQuotes.defaultProps = {
  onRemoveQuoteClicked: null,
};

export default KeyQuotes;
